<div class="wrapper v2" [ngClass]="theme()">
    <div class="options" [style.width.px]="width()">
        @for(option of options(); track option; let i = $index; let last = $last;) {
        <div
            class="item"
            [attr.data-cy-arrowchoices]="option"
            [style.text-align]="textDirection()"
            [style.padding]="last? 0 : itemPadding"
            [class.active]="i === selected()"
            (click)="selectOption(i)"
        >
            <span #itemtext>{{ option }}</span>
        </div>
        }
    </div>
    <div class="arrow" [style.transform]="transformRight" [style.transition]="transition"></div>
</div>
